// eslint-disable-next-line max-classes-per-file
import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import {withGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {DefaultRegistrationNew} from './DefaultRegistrationNew';
import FastRegistrationPromocode from 'app/components/auth/FastRegistrationPromocode';
import FastRegistrationTerms from 'app/components/auth/FastRegistrationTerms';
import FastRegistrationSingWithGoogle from 'app/components/auth/FastRegistrationSingWithGoogle';

/*
 * Import FastRegistrationSingWithSteam from 'app/components/auth/FastRegistrationSingWithSteam';
 */
import {DefaultRegistrationInterface} from 'app/interfaces/DefaultRegistrationInterface';
import {configStore, userStore} from 'app/store/global';
import {observer} from 'mobx-react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

type FastRegistrationEmailState = DefaultRegistrationNew['state'] & {
    emailFieldsVisible: boolean;
    countrySelectorVisible: boolean;
};

@observer
class FastRegistrationWithEmailContent extends DefaultRegistrationNew {
    declare state: FastRegistrationEmailState;

    static LEAD_FIELDS = ['password', 'email'];

    static METHOD = 'fast';

    constructor(props: DefaultRegistrationInterface) {
        super(props);
        this.state = {
            ...this.state,
            countrySelectorVisible: false,
            emailFieldsVisible: false
        } as FastRegistrationEmailState;
    }

    toggleCountryCode = (): void => {
        (this.setState as (state: Partial<FastRegistrationEmailState>) => void)({
            countrySelectorVisible: !this.state.countrySelectorVisible
        });
    };

    toggleEmailFields = (): void => {
        (this.setState as (state: Partial<FastRegistrationEmailState>) => void)({
            emailFieldsVisible: !this.state.emailFieldsVisible
        });
    };

    handleSignUp = async(e: React.FormEvent<HTMLFormElement>): Promise<void> => {
        if (!this.state.emailFieldsVisible) {
            e.preventDefault();
            (this.setState as (state: Partial<FastRegistrationEmailState>) => void)({emailFieldsVisible: true});
            return;
        }

        await this.signUp(e);
    };

    componentDidUpdate(
        prevProps: DefaultRegistrationInterface,
        prevState: FastRegistrationEmailState
    ): void {
        super.componentDidUpdate(prevProps, prevState);

        const hasErrors = Object.keys(this.state.errors).length > 0;
        const hadErrors = Object.keys(prevState.errors).length > 0;

        if (hasErrors && !hadErrors && !this.state.emailFieldsVisible) {
            (this.setState as (state: Partial<FastRegistrationEmailState>) => void)({emailFieldsVisible: true});
        }
    }

    getCountryName(): string {
        const country = configStore.REG_FLAGS.find(item => item.code === userStore.signUpCountry);
        return country?.name || '';
    }

    getPromocode = (): string | undefined => {
        const promocodeInput = document.getElementById('field-promocode') as HTMLInputElement | null;

        return promocodeInput?.value;
    };

    render(): ReactNode {
        return this.state.success
            ? <div>{this.state.success}</div>
            : <form id="fast-sign-up" onSubmit={this.handleSignUp} ref={this.rootForm}
                className="form-popup popup-form--error" autoComplete="new-password">
                <span className="form-title">{I18n.t('register')}</span>
                <div className="fast-registration-with-email">
                    <FastRegistrationSingWithGoogle
                        redirectUrl={this.props.redirectUrl}
                        usingOnTab={this.props.usingOnTab}
                        getPromocode={this.getPromocode}
                    />
                    <div className="registration-sign-with">
                        <div className="registration-sign-with__title">
                            <button
                                type="button"
                                className="button-registration button-registration--email-toggle"
                                onClick={this.toggleEmailFields}
                            >
                                <span className="icon">
                                    <SpriteIcon
                                        name="#svg-add"
                                        className={`svg-default ${this.state.emailFieldsVisible ? 'icon-rotated' : ''}`}
                                    />
                                </span>
                                <span className="name">{I18n.t('register_with_email')}</span>
                            </button>
                        </div>
                        <div className="registration-sign-with__divider" />
                        {this.state.emailFieldsVisible &&
                            <>
                                {this.rowName()}
                                {this.rowEmail()}
                                {this.rowPassword(true)}
                                {!this.state.countrySelectorVisible &&
                                    <div className="fast-registration-user-country">
                                        <span className="user-country-title">
                                            {`${I18n.t('user_country') } ${ this.getCountryName()}`}?
                                        </span>
                                        <button
                                            type="button"
                                            className="button-user-country"
                                            onClick={this.toggleCountryCode}
                                        >
                                            {I18n.t('change')}
                                        </button>
                                    </div>
                                }
                                {this.state.countrySelectorVisible && this.rowCountryCode()}
                                {this.rowCaptcha()}
                                <div className="popup-form__submit-row">
                                    {this.renderRegisterButton(I18n.t('chek_up'))}
                                </div>
                            </>
                        }
                    </div>
                    <input
                        name="site_lang"
                        type="hidden"
                        value={configStore.CONFIG?.lang}
                    />
                    <input name="full_registered" type="hidden" value="0"/>
                    <FastRegistrationPromocode/>
                    <FastRegistrationTerms/>
                    {/*
                    <FastRegistrationSingWithSteam
                        redirectUrl={this.props.redirectUrl}
                        usingOnTab={this.props.usingOnTab}
                        getPromocode={this.getPromocode}
                    />
                    */}
                </div>
            </form>;
    }
}

export default withGoogleReCaptcha(FastRegistrationWithEmailContent);
